// useTableColumnsNotificacionInventario.tsx

import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { NotificacionInventario } from "../types";
import { calcColorCalculatorMaterialUI, emptyCellObject, formatDate, formatDateWithTimeAMPM } from "@/shared";
import { Chip } from "@mui/material";

export function useTableColumnsNotificacionInventario() {

  const columns = useMemo<MRT_ColumnDef<NotificacionInventario>[]>(
    () => [
      {
        id: 'numero_referencia',
        accessorKey: "numero_referencia",
        header: "# Referencia",
        Cell: ({ row }) => row.original.numero_referencia
      },
      {
        id: 'bodega_origen',
        accessorKey: "bodega_origen_data.nombre",
        header: "Bodega Origen",
        Cell: ({ row }) => emptyCellObject(row.original.bodega_origen_data, 'nombre')
      },
      {
        id: 'ubicacion_origen',
        accessorKey: "ubicacion_origen_data.nombre",
        header: "Ubicación Origen",
        Cell: ({ row }) => emptyCellObject(row.original.ubicacion_origen_data, 'nombre')
      },
      {
        id: 'bodega_destino',
        accessorKey: "bodega_destino_data.nombre",
        header: "Bodega Destino",
        Cell: ({ row }) => emptyCellObject(row.original.bodega_destino_data, 'nombre')

      },
      {
        id: 'ubicacion_destino',
        accessorKey: "ubicacion_destino_data.nombre",
        header: "Ubicación Destino",
        Cell: ({ row }) => emptyCellObject(row.original.ubicacion_destino_data, 'nombre')
      },
      {
        id: 'estado_notificacion_inventario',
        accessorKey: 'estado_notificacion_inventario',
        header: 'Estado',
        Cell: ({ row }) => {
          const estado = row.original.estado_notificacion_inventario;
          return <Chip 
          variant="outlined"
          color={calcColorCalculatorMaterialUI(estado) as any}
          label={estado} />
        }
      },
      {
        id: 'motivo',
        accessorKey: 'motivo_data.nombre',
        header: 'Motivo',
        Cell: ({ row }) => emptyCellObject(row.original.motivo_data, 'nombre')
      },
      {
        id: 'solicitado_por',
        accessorKey: 'solicitado_por',
        header: 'Solicitado Por'
      },
      {
        id: 'fecha_creacion',
        accessorKey: 'fecha_creacion',
        header: 'Fecha Creación',
        Cell: ({ row }) => formatDateWithTimeAMPM(row.original.fecha_creacion)
      },
      {
        id: 'fecha_modificacion',
        accessorKey: 'fecha_modificacion',
        header: 'Ultima Modificación',
        Cell: ({ row }) => formatDateWithTimeAMPM(row.original.fecha_modificacion)
      },
    ],
    []
  );

  return {
    columns
  };
}
